import { MARKETS_VIEW, ODDS_VIEW } from "../constants";
import {
  ADD_TO_FILTER_SELECTIONS,
  ADD_TO_ODDS_SELECTIONS,
  REMOVE_FROM_FILTER_SELECTIONS,
  SELECT_FAVOURITE,
} from "../constants/actions";

export const selectOddsAndUpdateFilter = (odds) => (dispatch) => {
  dispatch({
    type: ADD_TO_ODDS_SELECTIONS,
    payload: {
      filter: ODDS_VIEW,
      odds: {
        minOdds: odds.minOdds,
        maxOdds: odds.maxOdds,
        isDecimal: odds.isDecimal ?? false,
      },
    },
  });

  dispatch({
    type: SELECT_FAVOURITE,
    payload: "",
  });
};

export const removeOddsAndUpdateFilter = () => (dispatch) => {
  dispatch({
    type: "REMOVE_FROM_ODDS_SELECTIONS",
    payload: {
      filter: ODDS_VIEW,
    },
  });
};

export const addMarketsAndUpdateFilter = (marketType) => (dispatch) => {
  dispatch({
    type: ADD_TO_FILTER_SELECTIONS,
    payload: {
      filter: MARKETS_VIEW,
      type: marketType,
    },
  });

  dispatch({
    type: SELECT_FAVOURITE,
    payload: "",
  });
};

export const removeMarketsAndUpdateFilter = (marketType) => (dispatch) => {
  dispatch({
    type: REMOVE_FROM_FILTER_SELECTIONS,
    payload: {
      filter: MARKETS_VIEW,
      type: marketType,
    },
  });

  dispatch({
    type: SELECT_FAVOURITE,
    payload: "",
  });
};
